import { createRouter } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen.js";

/**
 * The router.
 *
 * The route tree is GENERATED from the files under `src/routes/` by
 * `@tanstack/router-plugin` — see `routeTree.gen.ts`, which is committed but never hand-edited.
 * Adding a route means adding a file; nothing here changes.
 */
export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
